import Phaser from 'phaser';
import { FONT_FAMILY, FONT } from './FontLoader';

export function showFloatingNumber(
  scene: Phaser.Scene,
  x: number,
  y: number,
  value: number,
  type: 'damage' | 'heal' | 'block',
): void {
  const color = type === 'damage' ? '#ff4444' : type === 'heal' ? '#44ff44' : '#4488ff';
  const prefix = type === 'damage' ? '-' : '+';
  const text = scene.add.text(x, y, `${prefix}${value}`, {
    fontFamily: FONT_FAMILY,
    fontSize: FONT.heading,
    color,
    fontStyle: 'bold',
    stroke: '#000000',
    strokeThickness: 3,
  }).setOrigin(0.5).setDepth(200);

  scene.tweens.add({
    targets: text,
    y: y - 50,
    alpha: 0,
    scale: 1.3,
    duration: 900,
    ease: 'Quad.easeOut',
    onComplete: () => text.destroy(),
  });
}

export function showComboPopup(
  scene: Phaser.Scene,
  x: number,
  y: number,
  comboName: string,
): void {
  const text = scene.add.text(x, y, comboName, {
    fontFamily: FONT_FAMILY,
    fontSize: FONT.heading,
    color: '#ffd700',
    fontStyle: 'bold',
    stroke: '#000000',
    strokeThickness: 4,
  }).setOrigin(0.5).setDepth(200).setScale(0.3);

  scene.tweens.add({
    targets: text,
    scale: 1.2,
    duration: 300,
    ease: 'Back.easeOut',
    onComplete: () => {
      scene.tweens.add({
        targets: text,
        alpha: 0,
        y: y - 30,
        duration: 600,
        delay: 400,
        ease: 'Power2',
        onComplete: () => text.destroy(),
      });
    },
  });
}

export function hitFlash(
  scene: Phaser.Scene,
  target: Phaser.GameObjects.Rectangle,
): void {
  const originalColor = target.fillColor;
  target.setFillStyle(0xffffff);
  scene.time.delayedCall(80, () => {
    target.setFillStyle(originalColor);
  });
}
